import { getLeagueLogoUrl } from '../../urls';
import { LEAGUE_NAMES, type ESPNLeagueId } from '../../../shared';
import { LIGHT, bbox, leagueBuilder, team } from '../builders';
import type { LogoVsLogoLeague } from '../types';

const ID: ESPNLeagueId = 'brasileirao-copinha';
const { uniform } = leagueBuilder(ID);

const teams = [
  team('centro-olimpico', 'Centro Olímpico', uniform('centro-olimpico', LIGHT, '#960106')),
  team('olimpico', 'Olímpico EC', uniform('olimpico-ec', LIGHT, '#000000')),
  team('forte', 'Forte', uniform('forte', '#050D4E', LIGHT))
];

export const copinha: LogoVsLogoLeague = {
  value: ID,
  label: LEAGUE_NAMES[ID],
  logo: { src: getLeagueLogoUrl(ID), bbox: bbox(35, 44, 396, 94) },
  teams
};
